import type { CSS } from '../../stitches.config';
import { type SizingScale, isSpacingValue } from './sizes';

export type HeightTypes = SizingScale | string;
export type HeightProps = { height?: HeightTypes };

export const heightCSS = (height?: HeightTypes): CSS => {
  if (
    height === 'auto' ||
    height === 'fit-content' ||
    height === 'max-content' ||
    height === 'min-content'
  ) {
    return { height };
  }

  if (height === 'full') {
    return { height: '100%' };
  }

  if (height === 'screen') {
    return { height: '100dvh' };
  }

  if (typeof height === 'number' && isSpacingValue(height)) {
    return { height: `$${height}` };
  }

  if (typeof height === 'string') {
    return { height };
  }

  return {};
};
